<template>
    <div>
        <fluke-card>
            <header v-if="pagePermission.write||sessionId==id">
                <div class="title">Editar Usuário</div>
                <div class="description">Altere as informações do usuário</div>
            </header>
            <header v-else>
                <div class="title">Visualizar Usuário</div>
                <div class="description">Alterações desabilitadas para este perfil</div>
            </header>

            <main>
                <v-text-field
                    label="Usuário"
                    name="edit-user"
                    readonly
                    v-model="user">
                </v-text-field>

                <fluke-button v-on:click.native="changePass" :disabled="(pagePermission.write||sessionId==id)?false:true">Alterar senha</fluke-button>

                <v-data-table
					:headers="headers"
					:items="usersPermissions"
					:rows-per-page-items="[100]"
					rows-per-page-text="Linhas pos página"
					class="inner-tables"
                    v-if="pagePermission.write">

					<template v-slot:items="props">
						<td>{{ props.item.title }}</td>
						<td>
                            <v-switch
                                v-model="props.item.read"
                                label=""
                                @click.native="checkDep(props.item.permission,'read')"
                                @click="function(){}">
                            </v-switch>
                        </td>
						<td>
                            <v-switch
                                v-model="props.item.write"
                                label=""
                                @click.native="checkDep(props.item.permission,'write')"
                                @click="function(){}">
                            </v-switch>
                        </td>
					</template>
				</v-data-table>
            </main>
            <footer>
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button v-on:click.native="submit" v-if="pagePermission.write||sessionId==id">Salvar</fluke-button>
            </footer>
        </fluke-card>

        <div class="right" v-if="pagePermission.write||sessionId==id">
            <a v-on:click="remove" class="remove-links">Remover Usuário</a>
        </div>

        <global-popup ref="alert" title="Alerta!">O usuário admin deve sempre ter todas as permissões.</global-popup>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import permission from '../../mixins/permissions';


export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            sessionId: 0,
            id: '',
            user: '',
            password: '',
            permission: '',
            headers: [
                { text: 'Permissão', align: 'left', value: 'permission', sortable: false },
                { text: 'Leitura', align: 'left', value: 'read', sortable: false },
                { text: 'Escrita', align: 'left', value: 'write', sortable: false }
            ],
            usersPermissions: [],
            popupTitle: '',
            popupMessage: '',
            isAlert: false,
            pagePermission: {
                read: false,
                write: false
            }
        }
    },
    created: function(){
        this.getData();
        this.pagePermission = this.getUserPagePermission('users');
        this.sessionId = this.$route.params.id;
        if( !this.pagePermission.write && this.sessionId != this.$route.params.id ) {
			this.$router.push('/');
		}
    },
    methods: {
        changePass() {
            this.$router.push({ name: 'users-pass', params: { id: this.sessionId } });
        },
        getData: async function(){
            this.id = this.$route.params.id;
            axios.get(
				this.$myServerAddresses.admin + 'users/' + this.id,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            )
            .then( result => {
                this.id = result.data.id;
                this.user = result.data.user;
                this.password = '****';

                try {
                    this.permission = JSON.parse(result.data.permission);
                    this.permission = this.permission?this.permission:[];
                } catch(e) {
                    this.permission = [];
                }

                var globalPermissions = this.$store.state.permissions;
                globalPermissions.forEach( el => {
                    var value = this.permission.find( perm => perm.type == el.value );
                    value = value?value:{read:false,write:false};

                    this.usersPermissions.push({
                        permission: el.value,
                        title: el.title,
                        read: value.read,
                        write: value.write
                    });
                });
            })
        },
        submit: async function() {
            const perm = this.usersPermissions.map(el => {
                return {
                    type: el.permission,
                    read: el.read,
                    write: el.write
                }
            });
            await axios.put(
				this.$myServerAddresses.admin + 'users',
				{
                    id: this.id,
                    permission: JSON.stringify(perm)
				},
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'users' });
        },
        remove: async function () {
            if( confirm('Deseja remover este usuário?') )
            {
                const result = await axios.delete(
                    this.$myServerAddresses.admin + 'users/' + this.id,
                    {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        }
                    }
                );
                this.$router.push({ name: 'users' });
            }
        },
        cancel: function() {
            this.$router.push({ name: 'users' });
        },
        checkDep: function(permission, action) {
            if(this.user == 'flukeadmin' ){
                this.$refs.alert.alert();
                this.usersPermissions = this.usersPermissions.map( el => {
                    el.write = true;
                    el.read = true;
                    return el;
                });
            } else {
                this.usersPermissions = this.usersPermissions.map( el => {
                    if( el.permission == permission ){
                        if( action == 'write' ){
                            if( !el.write ){
                                el.write = true;
                                el.read = true;
                            } else {
                                el.write = false;
                            }
                        } else {
                            if( el.read && el.write ) {
                                el.write = false;
                                el.read = false;
                            } else {
                                el.read = !el.read;
                            }
                        }
                    }
                    return el;
                });
            }
        }
    }
}
</script>
